export const config = {
    abqMainHeaderHeight: 57,
    abqPageHeaderHeight: 53,
    abqCloseModalAnimationTime: 500
};
